let imtypes = ["Door to Door", "Door to Port", "Port to Door", "Port to Port"];
export default imtypes;
